import { useEffect, useMemo } from 'react'
import { useScalePoint } from 'hooks/useScalePoint'
import { useBreak } from 'hooks/useBreak'

export const useZppSetup = (bounds, ref, dimensions, setScale, mode, pin) => {
  const isMobile = useBreak('md_dn');

  const scale = useScalePoint(bounds, dimensions, mode, isMobile) + (isMobile ? (pin > 0 ? 0 : 0) : (pin > 0 ? 0 : 0));

  useEffect(() => {
    ref.current?.zoomToElement('center', scale, 0, null);
    ref.current?.centerView(scale, 0);
    setScale(scale || 1);
  }, [scale, bounds, mode, setScale, ref]);

  return useMemo(
    () => ({
      wrapperProps: {
        wheel: { step: 0.04 },
        limitToBounds: true,
        alignmentAnimation: { sizeX: 0, sizeY: 0 },
        zoomAnimation: { size: 0 },
        minScale: scale ?? 0,
        maxScale: scale ? 8 : 0,
        onInit: (event) => event.zoomToElement('center', scale, 0, null),
        onZoom: (event) => setScale(event.state.scale),
        // panning: { disabled: true }
        disablePadding: true,
      },
      wrapperStyle: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        overflow: 'hidden',
        willChange: 'transform',
      },
      contentStyle: {
        width: dimensions.W,
        height: dimensions.H,
        overflow: 'hidden',
        willChange: 'transform',
      },
    }),
    [scale, dimensions, setScale],
  );
};
